import type { WebContainerProcess } from "./types";

interface NodepodProcessLike {
  on(event: "output" | "error" | "exit", handler: (arg: any) => void): unknown;
  write(data: string): void;
  kill(): void;
  completion: Promise<{ exitCode: number }>;
}

export function wrapProcess(proc: NodepodProcessLike): WebContainerProcess {
  let closed = false;
  const output = new ReadableStream<string>({
    start(controller) {
      proc.on("output", (chunk: string) => { if (!closed) controller.enqueue(chunk); });
      proc.on("error", (chunk: string) => { if (!closed) controller.enqueue(chunk); });
      proc.on("exit", () => {
        closed = true;
        try { controller.close(); } catch { /* already closed */ }
      });
    },
    cancel() { closed = true; },
  });

  const input = new WritableStream<string>({
    write(chunk) { proc.write(chunk); },
  });

  const exit = proc.completion.then((r) => r.exitCode).catch(() => 1);

  return {
    output,
    input,
    exit,
    kill: () => proc.kill(),
    resize: () => {},
  };
}
